"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Truncate = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Truncate_module_css_1 = __importDefault(require("./Truncate.module.css"));
// eslint-disable-next-line jsdoc/require-jsdoc
function Truncate({ children }) {
    return (0, jsx_runtime_1.jsx)("div", { className: Truncate_module_css_1.default.truncate, children: children });
}
exports.Truncate = Truncate;
//# sourceMappingURL=Truncate.js.map